/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthView } from '../models/AuthView';
import type { ForgotPasswordRequest } from '../models/ForgotPasswordRequest';
import type { LoginRequest } from '../models/LoginRequest';
import type { RegisterRequest } from '../models/RegisterRequest';
import type { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import type { SuccessView } from '../models/SuccessView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * Register a new user
     * @param requestBody
     * @returns AuthView User registered successfully
     * @throws ApiError
     */
    public static postAppAuthRegister(
        requestBody: RegisterRequest,
    ): CancelablePromise<AuthView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or user already exists`,
                422: `Captcha verification failed`,
            },
        });
    }
    /**
     * Login user
     * @param requestBody
     * @returns AuthView Login successful
     * @throws ApiError
     */
    public static postAppAuthLogin(
        requestBody: LoginRequest,
    ): CancelablePromise<AuthView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Invalid credentials or invalid two-factor code`,
                403: `Two-factor authentication required`,
                422: `Captcha verification failed`,
            },
        });
    }
    /**
     * Verify email address
     * @param token
     * @returns SuccessView Email verified successfully
     * @throws ApiError
     */
    public static getAppAuthVerifyEmail(
        token: string,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/auth/verify-email/{token}',
            path: {
                'token': token,
            },
            errors: {
                400: `Invalid or expired token`,
            },
        });
    }
    /**
     * Resend verification email (requires auth)
     * @returns SuccessView Verification email sent
     * @throws ApiError
     */
    public static postAppUserResendVerification(): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/auth/resend-verification',
            errors: {
                400: `Email already verified`,
            },
        });
    }
    /**
     * Request password reset
     * @param requestBody
     * @returns SuccessView Password reset email sent (if user exists)
     * @throws ApiError
     */
    public static postAppAuthForgotPassword(
        requestBody: ForgotPasswordRequest,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/auth/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reset password with token (returns auth token for immediate login)
     * @param requestBody
     * @returns AuthView Password reset successful, returns auth token
     * @throws ApiError
     */
    public static postAppAuthResetPassword(
        requestBody: ResetPasswordRequest,
    ): CancelablePromise<AuthView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/auth/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or expired token`,
            },
        });
    }
}
